import type { Lang } from './translations';

export const LANG_STORAGE_KEY = 'rezervo_lang';

export function isValidLang(value: string | null | undefined): value is Lang {
  return value === 'sq' || value === 'en';
}

export function getStoredLang(): Lang | null {
  if (typeof window === 'undefined') return null;
  try {
    const stored = window.localStorage.getItem(LANG_STORAGE_KEY);
    return isValidLang(stored) ? stored : null;
  } catch {
    return null;
  }
}

export function setStoredLang(lang: Lang): void {
  if (typeof window === 'undefined') return;
  try {
    window.localStorage.setItem(LANG_STORAGE_KEY, lang);
  } catch {
    // localStorage unavailable (private mode, etc.) — in-memory state still works
  }
}

// Used by the global provider on mount. No query-param awareness here —
// only booking pages need that, and they resolve it themselves via
// resolveLangFromSearchParam below, then push the result through setLang().
export function resolveInitialLang(): Lang {
  return getStoredLang() ?? 'sq';
}

// Used by booking-flow pages that read `?lang=` themselves. Query param
// wins if valid; otherwise falls back to whatever the caller passes in
// (normally the current global lang, which is itself localStorage-or-default).
export function resolveLangFromSearchParam(
  paramValue: string | null | undefined,
  fallback: Lang
): Lang {
  return isValidLang(paramValue) ? paramValue : fallback;
}
